import * as React from "react";

export const LinkToUserField = ({
  record = { user_id: "", user_email: "" },
}) => {
  const link = `/users#/users/${record.user_id}`;
  return <a href={link}>{record.user_email}</a>;
};
LinkToUserField.defaultProps = { label: "User" };
